import styled from '@emotion/styled';
import { UDText } from 'ud-ui/components';
import { theme } from 'styles/theme/theme';

export const MainBlock = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  gap: 8px; /* соответствие gap-2 */
`;

export const AvatarImage = styled.img`
  height: 40px;
  width: 40px;
  min-width: 40px;
  border-radius: ${({ theme }) => theme.radii.card};
  border: 1px solid ${theme.colors.LineStrong};
  object-fit: cover;
`;

export const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  justify-content: center;
  gap: 4px; /* gap-1 */
  overflow: hidden; /* для корректной работы ellipsis */
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const TitleTruncate = styled(UDText)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; /* аналог className="truncate" */
`;
